import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import { useStores } from "../../stores";
import NoImage from "../../assets/images/noImage.jpg";
import Header from "../../components/Header";
import notify from "../../components/Notify/notify";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

const PaymentFailed = () => {
  const { bookingStore } = useStores();
  const { state } = useLocation();
  const [couponDiscount, setInventoryPrice] = useState([]);
  const [selectedSpaceItem, setSelectedSpaceItem] = useState([]);
  const [selectedInvItem, setSelectInvItem] = useState([]);
  const selectSpaceItem = sessionStorage.getItem("selectSpaceItem");
  const selectInverntoryItem = sessionStorage.getItem("selectInverntoryItem");
  const selectedDate = sessionStorage.getItem("selectedDate");
  const selectSlotItem = sessionStorage.getItem("selectSlotItem");
  let parseDate = JSON.parse(selectedDate);
  const [selectDate, setSelectDate] = useState(parseDate);
  const [selectSlot, setSelectSlot] = useState([]);
  const [accessKey, setAccessKey] = useState("");
  const [campaign, setCampaign] = useState({});
  const [spaceName, setSpaceName] = useState("");
  const [selectedSpaceItemId, setSelectedSpaceItemId] = useState("");
  const [coupon, setCoupon] = useState("");
  const [orderedFnbList, setOrderedFnbList] = useState([]);
  const navigate = useNavigate();

  const retryData = sessionStorage.getItem('retryData')
  console.log('retryData ',retryData);

  const [inventryData, setInventryData] = useState({});
  const [bookingData, setBookingData] = useState({});
  const [amount, setAmount] = useState({});
  const [startTime, setStartTime] = useState([]);
  const [endTime, setEndTime] = useState([]);
  const [bookingDate, setBookingDate] = useState("");
  const [loader, setLoader] = useState(false);
  const [currentPathname, setCurrentPathname] = useState(null);
  const [currentSearch, setCurrentSearch] = useState(null);
  let newvar = window.location.pathname;
  let tempData = newvar.split("/payment/failed/")[1];
  let access_key = tempData.split("/")[0];

  const [dayPassPayment, setDayPassPayment] = useState(false);

  useEffect(() => {

    setAccessKey(access_key);
    let txnId = tempData.split("/")[1];
    // console.log(tempData);
    getPaymentStatus(access_key, txnId);

    // window.history.pushState(null, null, newvar);
    window.onpopstate = function () {
      window.history.go(1);
    };
  }, []);

  const getPaymentStatus = async (key, txnId) => {
    setLoader(true);
    let params = `access_key=${key}&txn_id=${txnId}`;
    await bookingStore.getBookingStatus(params,async (response) => {
      if (response?.data?.status === 1) {
        setBookingData(response?.data?.data);
        let tempTime = response?.data?.data?.booking_data?.valid_from;
        let fnbData = response?.data?.data.fnb_data;
        let bookingDate = tempTime?.split(" ")[0];
        let startTime = tempTime?.split(" ")[1];
        setOrderedFnbList(response?.data?.data.fnb_data);
        getBookingDate(bookingDate);
        await getInventoryPrice(response?.data?.data?.booking_data, response?.data?.data?.booking_data?.inventory_name, response?.data?.data?.quantity)
        setStartTime(
          `${startTime?.split(":")[0]}:${startTime?.split(":")[1]?.split(":")[0]
          }`
        );
        let tempEndTime = response?.data?.data?.booking_data?.valid_upto;
        let endTime = tempEndTime?.split(" ")[1];
        setEndTime(
          `${endTime?.split(":")[0]}:${endTime?.split(":")[1]?.split(":")[0]}`
        );
        let price = 0;
        fnbData.forEach(element => {
          price = price + Number(element.price)
        });
        console.log(price);
        setAmount(price)
      } else {
        console.log("error");
        setLoader(false);
      }
    });
  };

  const getInventoryPrice = async(item, dayPass, quantity) =>{
    let params = '';
    dayPass = dayPass.trim().toLowerCase();
    if(dayPass === "day pass"){
      console.log("inside inventory daypass");
      setDayPassPayment(true)

      const urlParams = sessionStorage.getItem('urlParams');
      if (urlParams) {
        const currentURL = window.location.href;
        const newURL = currentURL + (currentURL.includes('?') ? '&' : '?') + urlParams;
        window.history.replaceState({}, document.title, newURL);
      }

      params = `inventory_id=${item.inventory_id}&duration_type_id=${2}&valid_from=${item.valid_from}&valid_upto=${item.valid_upto}&access_key=${access_key}&custom_booking_qty=${quantity}&custom_booking_type=Day%20Pass`;
    }else{
      console.log("else inventory pass");
     params = `inventory_id=${item.inventory_id}&duration_type_id=${1}&valid_from=${item.valid_from}&valid_upto=${item.valid_upto}&access_key=${access_key}`;
    }
      await bookingStore.inventoryPrice(params, (response) => {
        if (response?.data?.status === 1) {
          setInventryData(response?.data?.data,"<==========")
          setLoader(false);
          //setInventoryPrice(response?.data?.data);
        } else {
          setLoader(false);
          console.log("error");
        }
      });
  }

  const getBookingDate = (date) => {
    const weekday = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    let tempDate = new Date(date).toLocaleString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    let day = weekday[new Date(tempDate).getDay()];
    setBookingDate(`${day}, ${tempDate}`);
  };

  return (
    <>
      <Header accessKey={accessKey} queryParams={window.location.origin + `/day-pass/${accessKey}`} dayPass={dayPassPayment} />
      {loader ? (
        <div className="loader"></div>
      ) : (
        <div className="payment-result-container">
          <section className="booking-listing-section">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="payment-detail-box pt-5">
                    <div className="row">
                      <div className="col-md-6  no-gutters">
                        <div className="payment-content">
                          <div className="banner-tag">
                            <h3 className="banner-tag-text">
                              {bookingData?.booking_data?.inventory_name}
                            </h3>
                          </div>
                          <img
                            src={
                              bookingData?.booking_data?.image[0] || NoImage
                            }
                            alt="Payment Banner"
                            className="payment-banner"
                          />
                          <h3 className="payment-content-heading">
                            {bookingData?.space_name}
                          </h3>
                          <p className="payment-content-text">
                            {bookingData?.address}
                          </p>
                          <div className="payment-date-box">
                            <p className="payment-date-text">{bookingDate}</p>
                            <p className="payment-date-text">
                              {startTime} - {endTime}
                            </p>
                            {!dayPassPayment && (
                              <p className="payment-date-text">
                                {bookingData?.booking_data?.capacity} Seater{" "}
                                {bookingData?.booking_data?.inventory_name}
                              </p>
                            )}

                             {dayPassPayment && (
                              <p className="payment-date-text">
                                {bookingData?.quantity} Quantity{" "}
                              </p>
                            )}

                          </div>
                          {!dayPassPayment && (
                            <div className="add-fb-setion">
                              <p className="modal-btn">F&B Detail</p>
                              {orderedFnbList && orderedFnbList.length > 0 ? (
                                <p className="order-id">Order Id - {bookingData?.pos_id}</p>
                              ) : (
                                <p className="order-id">No F&B Added</p>
                              )}
                            </div>
                          )}
                          {orderedFnbList && orderedFnbList?.map((item) => {
                            return (
                              <div className="list-box">
                                <div className="list-box-inner">
                                  <p className="list-box-fitem">{item.name}</p>
                                  <p className="list-box-litem">{Number(item?.price) * item?.qty}</p>
                                </div>
                                <div className="list-box-inner">
                                  <p className="list-box-sfitem">Qty</p>
                                  <p className="list-box-slitem">{item?.qty}</p>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="billing-detail-box success">
                          <h3 className="failed-message">
                            Oops! Your transaction has failed. Please try again.
                          </h3>
                          <div className="client-detail-box">
                            <h3 className="client-detai-heading failedclient">
                              Customer Details
                            </h3>
                            <div className="client-detail-inner">
                              <p className="cd-text">
                                Name: {bookingData?.user_data?.name}
                              </p>
                              <p className="cd-text">
                                Mobile Number: {bookingData?.user_data?.mobile}
                              </p>
                              <p className="cd-text">
                                Email Id: {bookingData?.user_data?.email}
                              </p>
                            </div>
                          </div>
                          <p className="billing-detail-heading">
                            Billing Details
                          </p>
                          <div className="total-price-box mt-2">
                            <div className="total-price-inner">
                              <p className="total-text">Sub Total</p>
                              <p className="text-price">
                                Rs {inventryData?.base_amount}
                              </p>
                            </div>
                            {/* <div className="total-price-inner">
                              <p className="total-text">SGST(9%)</p>
                              <p className="text-price">
                                Rs {inventryData?.booking_data?.sgst}
                              </p>
                            </div>
                            <div className="total-price-inner">
                              <p className="total-text">CGST(9%)</p>
                              <p className="text-price">
                                Rs {inventryData?.booking_data?.cgst}
                              </p>
                            </div> */}  
                            {inventryData?.tax_break_up?.map((item) => {
                            return (
                              <div className="total-price-inner">
                                <p className="total-text">{item?.name}</p>
                                <p className="text-price">Rs {item?.value}</p>
                              </div>
                            );
                          })}
                            {/* <div className="total-price-inner">
                              <p className="total-text">IGST(0%)</p>
                              <p className="text-price">
                                Rs {inventryData?.booking_data?.igst}
                              </p>
                            </div> */}
                            <div className="total-price-inner">
                              <p className="total-text">Discount</p>
                              <p className="text-price">
                                Rs {inventryData?.discount_amount}
                              </p>
                            </div>
                            <div className="total-price-inner-big">
                              <p className="total-text-big">Sub Total</p>
                              <p className="text-price-big">
                                Rs {inventryData?.total_amount}/-
                              </p>
                            </div>
                            <div className="total-price-inner">
                              {/* <p className="total-text">Add ons</p>
                              <p className="text-price">
                                {inventryData?.addon_amount}
                              </p> */}
                             {!dayPassPayment && (
                              <p className="total-text">
                                {orderedFnbList && orderedFnbList.length > 0
                                  ? "F&B"
                                  : "No F&B Added"}
                              </p>
                            )}
                              <p className="text-price">
                                {orderedFnbList && orderedFnbList.length > 0 &&
                                  amount}
                              </p>
                            </div>
                            <div className="total-price-inner-gbig">
                              <p className="total-text-gbig">Grand Total</p>
                              <p className="text-price-gbig">
                              {/* Rs {amount === 0 ? String(inventryData?.total_amount) : String(inventryData?.total_amount + amount)} /- */}
                              Rs {inventryData?.total_amount}/-
                              </p>
                            </div>

                            <div className="client-detail-box">
                              <button
                                className="retry-btn"
                                onClick={() =>{
                                  // navigate(
                                  //   `/${process.env.REACT_APP_BASE_FOLDER}/payment/${accessKey}`
                                let key = sessionStorage.getItem("acckey");
                                let data = sessionStorage.getItem("retryData");
                                let fnb = sessionStorage.getItem("selectedFnbList");
                                let selectedFnb = JSON.parse(fnb);
                                let retrydata = JSON.parse(data);
                                let item = retrydata?.item;
                                let inventoryId = retrydata?.inventoryId;
                                let selectedItems = retrydata?.selectedItems;
                                  if(retrydata?.screen === "retry" && retrydata !== null && retrydata !== undefined)
                               
                                  {
                                    navigate(`/payment/${key}`,
                                    { state: { item,inventoryId, selectedItems,selectedFnb, screen: 'direct',flag:"retry" } })
                                  }else if(dayPassPayment){
                                    const urlParams = sessionStorage.getItem('urlParams');
                                    navigate(`/day-pass/book-now/payment/${key}?${urlParams}`);
                                  }
                                  else{
                                  navigate(`/payment/${key}`,
                                  { state: { selectedFnb ,screen:'back',selectedFnb ,flag:"retry"} })
                                  }
                                }}
                              >
                                Retry
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
    </>
  );
};

export default PaymentFailed;
